// test1769
(1769 && 0);
